<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.7329 5.0755C13.0623 4.79791 15.4185 5.29032 17.4418 6.47755C19.465 7.66478 21.0441 9.48158 21.9379 11.6505C22.0213 11.875 22.0213 12.122 21.9379 12.3465C21.5704 13.2375 21.0847 14.075 20.4939 14.8365" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.0839 14.1561C13.5181 14.7025 12.7603 15.0049 11.9737 14.9981C11.1871 14.9912 10.4347 14.6757 9.87844 14.1195C9.32221 13.5633 9.0067 12.8109 8.99987 12.0243C8.99303 11.2377 9.29542 10.4799 9.84189 9.91406" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.479 17.4978C16.1525 18.2836 14.6725 18.7748 13.1394 18.9382C11.6063 19.1016 10.056 18.9333 8.59365 18.4447C7.13133 17.9561 5.79121 17.1587 4.66423 16.1066C3.53725 15.0544 2.64977 13.7722 2.06202 12.3468C1.97868 12.1223 1.97868 11.8753 2.06202 11.6508C2.94865 9.50067 4.50869 7.69606 6.50802 6.50781" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 2L22 22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#09090B',
    },
  },
};
</script>
